var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"xcard"},[_c('b',{staticClass:"text-primary"},[_vm._v("Registros por asesor")]),_c('canvas',{attrs:{"id":"chart-area7b"}})])])])
}]

export { render, staticRenderFns }